module.exports = require("@bigcommerce/form-poster");